import $ from 'jquery'
import 'foundation-sites'

window.$ = window.jQuery = $

if (!$.fn.foundation) {
  console.error('[Foundation] Foundation library failed to load. UI components may not function correctly.')

  if (window.Rollbar && typeof window.Rollbar.warning === 'function') {
    window.Rollbar.warning('[Foundation] Foundation library failed to load')
  }

  $.fn.foundation = function () {
    console.warn('[Foundation] Attempted to initialize Foundation, but the plugin is not available.')
    return this
  }

  window.Foundation = window.Foundation || {}

  class NoopPlugin {
    constructor (el) { this.$element = $(el) }
    destroy () {}
    open () {}
    close () {}
  }

  window.Foundation.Tooltip = window.Foundation.Tooltip || NoopPlugin
  window.Foundation.Reveal = window.Foundation.Reveal || NoopPlugin
  window.Foundation.OffCanvas = window.Foundation.OffCanvas || NoopPlugin
}

let foundationBooted = false

function bootFoundation () {
  if (foundationBooted) return
  if (typeof $.fn.foundation === 'function') {
    $(document).foundation()
    foundationBooted = true
  }
}

document.addEventListener('turbo:load', bootFoundation)
document.addEventListener('DOMContentLoaded', bootFoundation)
